const DataLoading = () => {
    return (<div className="page-on-loader">
        <div className="loader__indicator loader__indicator--bar">
        </div>
    </div>)
}

export default DataLoading